var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"resize-start-line-container",style:(_vm.style),on:{"mousedown":function($event){return _vm.mouseDownHandler(_vm.field.name, $event)},"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"resize-start-line",style:(_vm.lineStyle)})])
}
var staticRenderFns = []

export { render, staticRenderFns }